import BackendService from "./BackendService";
import { AUTH_YTPE } from "../const";

async function createSale(data) {
  return BackendService.post("/sales/create/", data, {}, {}, null, AUTH_YTPE.terminal);
}

async function createSaleV2(data) {
  return BackendService.post("/v2/sales/", data, {}, {}, null, AUTH_YTPE.terminal);
}

async function getSale(id) {
  return BackendService.getData(`/sales/${id}/`);
}

async function updateSale(id, data = {}) {
  return BackendService.patch(`/sales/${id}/`, data);
}

const SalesService = {
  createSale,
  createSaleV2,
  getSale,
  updateSale,
};

export default SalesService;
